import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertBmpToIco() {
  return <ImageConverterTemplate sourceFormat="BMP" targetFormat="ICO" acceptTypes=".bmp,image/bmp" slug="convert-bmp-to-ico" gradientColors="from-cyan-500 to-blue-600" accentColor="cyan" />;
}
